import { useAuth } from '@/auth/auth-context';
import { parseGraphQLResponse, useWorkspaceQuery } from '@/graphql';
import { FullPageLoader } from '@/components/loader';

import { accountSchema } from './types';
import { WorkspaceContext } from './workspace-context';

interface WorkspaceContextProviderProps {
  children: React.ReactNode;
}

export const WorkspaceContextProvider = ({ children }: WorkspaceContextProviderProps) => {
  const { user } = useAuth();

  const { data, loading } = useWorkspaceQuery({
    fetchPolicy: 'cache-and-network',
    skip: user === null || !user.emailVerified,
  });

  if (loading && location.pathname !== '/signup') {
    return <FullPageLoader />;
  }

  const workspaceData = {
    accounts: (data?.accounts ?? []).map((input) => parseGraphQLResponse(input, accountSchema)),
    user:
      data?.me !== undefined
        ? { email: data.me?.email ?? '', emailVerified: user?.emailVerified ?? false }
        : user,
  };

  return <WorkspaceContext.Provider value={workspaceData}>{children}</WorkspaceContext.Provider>;
};
